import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  DASHBOARD_DOMAIN_HOST,
  ROOT_DOMAIN_HOST,
  getCanonicalPathname,
  getRequiredDomainForPath,
  isDashboardDomainHost,
  isManagedDomainHost,
  isRootDomainHost,
} from "@/routing/domainRoutes";

export function DomainRouterGuard() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const { hostname } = window.location;
    if (!isManagedDomainHost(hostname)) return;

    const requiredDomain = getRequiredDomainForPath(location.pathname);
    const canonicalPathname = getCanonicalPathname(location.pathname);

    if (!requiredDomain && canonicalPathname === location.pathname) return;

    const alreadyCorrect =
      (requiredDomain === "root" && isRootDomainHost(hostname)) ||
      (requiredDomain === "dashboard" && isDashboardDomainHost(hostname)) ||
      (!requiredDomain && canonicalPathname === location.pathname);

    if (alreadyCorrect && canonicalPathname === location.pathname) return;

    const targetHost =
      requiredDomain === "root"
        ? ROOT_DOMAIN_HOST
        : requiredDomain === "dashboard"
          ? DASHBOARD_DOMAIN_HOST
          : hostname;
    const targetUrl = `https://${targetHost}${canonicalPathname}${location.search}${location.hash}`;
    const currentUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;

    if (targetUrl === currentUrl) return;

    window.location.replace(targetUrl);
  }, [location.hash, location.pathname, location.search]);

  return <Outlet />;
}
